import zod from 'zod';
import { MANDATORY_FIELD } from '../../../config/zodConfig';
import { IntegrationFormSchema } from '../schemas';

export const MoniIntegrationFormSchema = zod
  .object({
    serverIp: zod
      .string({ required_error: MANDATORY_FIELD })
      .min(1, MANDATORY_FIELD),
    httpPort: zod
      .string({ required_error: MANDATORY_FIELD })
      .min(1, MANDATORY_FIELD),
    username: zod
      .string({ required_error: MANDATORY_FIELD })
      .min(1, MANDATORY_FIELD),
    password: zod
      .string({ required_error: MANDATORY_FIELD })
      .min(1, MANDATORY_FIELD),
    occurrenceSet: zod
      .string({ required_error: MANDATORY_FIELD })
      .min(1, MANDATORY_FIELD),
    company: zod
      .string({ required_error: MANDATORY_FIELD })
      .min(1, MANDATORY_FIELD),
  })
  .merge(IntegrationFormSchema);
